import { Link } from "react-router-dom";
import { Logo } from "@/components/brand";
import { useLang, t, withLang } from "@/lib/i18n";

const YEAR = new Date().getFullYear();

const COLUMNS = [
  {
    label: { en: "Product", fr: "Produit" },
    links: [
      { to: "/for-merchants", label: { en: "For merchants", fr: "Pour marchands" } },
      { to: "/for-drivers", label: { en: "For drivers", fr: "Pour livreurs" } },
      { to: "/pricing", label: { en: "Pricing", fr: "Tarifs" } },
      { to: "/how-it-works", label: { en: "How it works", fr: "Comment ça marche" } },
    ],
  },
  {
    label: { en: "Company", fr: "Entreprise" },
    links: [
      { to: "/faq", label: { en: "FAQ", fr: "FAQ" } },
      { to: "/contact", label: { en: "Contact", fr: "Nous joindre" } },
      { to: "/apply", label: { en: "Apply to drive", fr: "Postuler comme livreur" } },
    ],
  },
  {
    label: { en: "Sign in", fr: "Se connecter" },
    links: [
      { to: "/login?role=merchant", label: { en: "Merchant login", fr: "Espace marchand" } },
      { to: "/login?role=driver", label: { en: "Driver login", fr: "Espace livreur" } },
    ],
  },
];

export default function Footer() {
  const lang = useLang();
  return (
    <footer className="bg-white border-t border-gray-200" data-testid="public-footer">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-14 lg:py-16">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {COLUMNS.map((col) => (
            <div key={t("en", col.label)}>
              <div className="font-mono text-[10px] tracking-[0.18em] uppercase text-gray-400 mb-4">
                {t(lang, col.label)}
              </div>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={withLang(l.to, lang)}
                      data-testid={`footer-${t("en", l.label).toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-gray-600 hover:text-[#0a0a0a] transition-colors"
                    >
                      {t(lang, l.label)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div>
            <div className="font-mono text-[10px] tracking-[0.18em] uppercase text-gray-400 mb-4">
              {t(lang, { en: "Contact", fr: "Nous joindre" })}
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">
              Routa Logistics Inc.<br />
              {t(lang, { en: "Vancouver, BC · Canada", fr: "Vancouver, C.-B. · Canada" })}
            </p>
            <a
              href="mailto:damiwilliams@routa.ca"
              data-testid="footer-email"
              className="mt-3 inline-block text-sm text-gray-600 hover:text-[#0a0a0a] transition-colors"
            >
              damiwilliams@routa.ca
            </a>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-gray-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <Logo />
            <span className="hidden sm:inline text-xs text-gray-400">
              {t(lang, { en: "AI-powered last-mile delivery.", fr: "Livraison du dernier kilomètre propulsée par l'IA." })}
            </span>
          </div>
          <span className="font-mono text-[11px] tracking-[0.14em] uppercase text-gray-400">
            © {YEAR} Routa Logistics Inc.
          </span>
        </div>
      </div>
    </footer>
  );
}
